import { Paper, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import AccessEventsDataGrid, { AccessEventRow } from 'v2/components/AccessEventsDataGrid/AccessEventsDataGrid';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useVisitorDetailsAccessEvents from 'v2/hooks/useVisitors/useVisitorDetailsAccessEvents';

interface Props {
  visitorId: string;
}

const AccessEventsTab: React.FC<Props> = ({ visitorId }) => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });

  const { visitorDetailsAccessEvents, loadingGetVisitorDetailsAccessEvents } = useVisitorDetailsAccessEvents({
    handleFetchError,
    visitorId
  });

  const rows: AccessEventRow[] = (visitorDetailsAccessEvents ?? []).map((event) => ({
    id: event.id,
    createdAt: event.createdAt,
    doorName: event.door.name,
    doorType: event.door.type,
    action: event.action,
    reason: event.reason
  }));

  return (
    <Paper elevation={3} sx={{ padding: '24px', borderRadius: 1, width: '100%' }}>
      <Stack spacing={2}>
        <Typography variant="h5" color="textPrimary">
          {translation.events}
        </Typography>
        <AccessEventsDataGrid
          className="background-level2 not-clickable"
          rows={rows}
          loading={loadingGetVisitorDetailsAccessEvents}
          hideUserColumn
        />
      </Stack>
    </Paper>
  );
};

export default AccessEventsTab;
